import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const UKFlag: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[16px]', className)}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_875_224)">
      <path d="M0 6.10352e-05H24V16.0004H0V6.10352e-05Z" fill="white" />
      <path
        d="M13.5 -6.10352e-05H10.5V6.49996H0V9.49999H10.5V16H13.5V9.49999H24V6.49996H13.5V-6.10352e-05Z"
        fill="#D80027"
      />
      <path
        d="M18.4587 10.7825L24 13.8611V10.7825H18.4587ZM14.6087 10.7825L24 16V14.5246L17.2644 10.7825H14.6087ZM21.4985 16L14.6087 12.1719V16H21.4985Z"
        fill="#0052B4"
      />
      <path d="M14.6087 10.7825L24 16V14.5246L17.2644 10.7825H14.6087Z" fill="white" />
      <path d="M14.6087 10.7825L24 16V14.5246L17.2644 10.7825H14.6087Z" fill="#D80027" />
      <path
        d="M4.23473 10.7824L0 13.1351V10.7824H4.23473ZM9.39131 11.4459V15.9999H1.19489L9.39131 11.4459Z"
        fill="#0052B4"
      />
      <path d="M6.73561 10.7825L0 14.5246V16L9.39131 10.7825H6.73561Z" fill="#D80027" />
      <path
        d="M5.54133 5.21736L0 2.13877V5.21736H5.54133ZM9.39131 5.21736L0 -6.10352e-05V1.4753L6.73561 5.21736H9.39131ZM2.50153 -6.10352e-05L9.39131 3.82797V-6.10352e-05H2.50153Z"
        fill="#0052B4"
      />
      <path d="M9.39131 5.21736L0 -6.10352e-05V1.4753L6.73561 5.21736H9.39131Z" fill="white" />
      <path d="M9.39131 5.21736L0 -6.10352e-05V1.4753L6.73561 5.21736H9.39131Z" fill="#D80027" />
      <path
        d="M19.7653 5.21734L24 2.86467V5.21734H19.7653ZM14.6087 4.55387V-0.00012207H22.8051L14.6087 4.55387Z"
        fill="#0052B4"
      />
      <path d="M17.2644 5.2173L24 1.47523V-0.00012207L14.6087 5.2173H17.2644Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_875_224">
        <rect y="6.10352e-05" width="24" height="16.0001" rx="2.00001" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UKFlag;
